"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdReviewStatusToJSON = exports.AdReviewStatusFromJSONTyped = exports.AdReviewStatusFromJSON = exports.AdReviewStatus = void 0;
/**
 * Review status when reviewing ads and ad sets.
 * @export
 */
exports.AdReviewStatus = {
    Approve: 'APPROVE',
    Reject: 'REJECT'
};
function AdReviewStatusFromJSON(json) {
    return AdReviewStatusFromJSONTyped(json, false);
}
exports.AdReviewStatusFromJSON = AdReviewStatusFromJSON;
function AdReviewStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AdReviewStatusFromJSONTyped = AdReviewStatusFromJSONTyped;
function AdReviewStatusToJSON(value) {
    return value;
}
exports.AdReviewStatusToJSON = AdReviewStatusToJSON;
